import { CollapsibleDataContainer } from 'components/reusable/CollapsibleDataContainer'
import { Banner } from 'slab'

import EmployerPlaidAccountTable from './EmployerPlaidAccountTable'

const EmployerPlaidAccountView = () => {
  const successContent = (
    <EmployerPlaidAccountTable />
  )

  const errorContent = (
    <Banner title='Error loading plaid account. Please try again later.' />
  )

  return (
    <CollapsibleDataContainer
      heading={<span className='heading-md'>Plaid account</span>}
      isLoading={false}
      error={false}
      localStorageKey='employer-plaid-account-view'
      loadingContent={<div>Loading plaid account...</div>}
      errorContent={errorContent}
      successContent={successContent}
    />
  )
}

export default EmployerPlaidAccountView
